module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_08@3x-011326e2cc3191a634a42d5dbe931f0b.webp";